// DEPLOY: /var/www/woody.wtf/frontend/src/components/NoveltyTag.js
// Small tag for an announcement's AI novelty label (market.announcements.novelty,
// written by analyse_announcements.py from the company's earlier announcements):
// FIRST / UPDATE / REPEAT / REVERSAL. Shown next to the significance dots on the
// Company, Announcements and AI Audit pages. First and reversal - the news most
// likely to move a price - stand out; update and repeat stay muted.
// Renders nothing for summaries written before novelty existed.
import React from 'react';

const TAGS = {
  first:    { title: 'New for this company - not seen in its earlier announcements',
              style: { borderColor: 'var(--accent)', color: 'var(--accent)', fontWeight: 600 } },
  reversal: { title: 'Undoes or reverses an earlier reported development',
              style: { borderColor: '#92400E', color: '#92400E', background: '#FEF3C7', fontWeight: 600 } },
  update:   { title: 'Progress on something already announced', style: {} },
  repeat:   { title: 'Restates earlier news with nothing material new', style: { opacity: 0.7 } },
};

const base = {
  display: 'inline-block', marginLeft: '6px', verticalAlign: 'middle', whiteSpace: 'nowrap',
  fontFamily: "'DM Mono', monospace", fontSize: '9px', letterSpacing: '0.06em', lineHeight: 1.4,
  padding: '0 5px', borderRadius: 'var(--radius)', border: '1px solid var(--border)', color: 'var(--text-muted)',
};

export default function NoveltyTag({ n }) {
  const t = TAGS[n];
  return t ? <span style={{ ...base, ...t.style }} title={t.title}>{n.toUpperCase()}</span> : null;
}
